/* eslint-disable camelcase */

import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

const transformGuests = (eventGuests) =>
  eventGuests.map(
    ({
      id,
      firstname,
      lastname,
      email,
      company_name,
      mobile_phone,
      guest_id,
    }) => ({
      id,
      firstname,
      lastname,
      email,
      company_name,
      mobile_phone,
      guest_id,
    }),
  );

export const saveRequest = (userId, eventGuests) =>
  axios.put(Routes.event_guests_user_path(userId, { format: 'json' }), {
    event_guests: transformGuests(eventGuests),
  });
